import { __read, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useState, useRef } from 'react';
import { CloseIcon } from '../../icons/CloseIcon.js';
import { Tooltip } from '../../base/tooltip/Tooltip.js';
import { ListBox } from '../../base/listBox/ListBox.js';
import { Popover } from '../../base/popover/Popover.js';
import { useDropdown } from '../../hooks/useDropdown/useDropdown.js';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon.js';
import styles from './FilterDropdown.module.scss.js';

var FilterDropdown = function (_a) {
    var _b;
    var _c;
    var className = _a.className, listboxWrapperClassName = _a.listboxWrapperClassName, style = _a.style, inputProps = _a.inputProps, _d = _a.isClearable, isClearableProp = _d === void 0 ? true : _d, children = _a.children, label = _a.label, name = _a.name, _e = _a.withTriggerIcon, withTriggerIcon = _e === void 0 ? false : _e;
    var _f = useDropdown({
        children: children,
        label: label,
        inputProps: inputProps,
    }), state = _f.state, triggerProps = _f.triggerProps, triggerRef = _f.triggerRef, listboxProps = _f.listboxProps;
    var _g = __read(useState(false), 2), isHovered = _g[0], setHovered = _g[1];
    var clearableTimeoutRef = useRef();
    var isClearable = !!state.selectedItem && isHovered && !state.isOpen && isClearableProp;
    return (jsxs(Fragment, { children: [jsxs("button", __assign({}, triggerProps, { className: clsx(styles.filterDropdown, className, (_b = {},
                    _b[styles.filterDropdownOpened] = state.isOpen,
                    _b[styles.filterDropdownClearable] = isClearable,
                    _b)), "aria-labelledby": undefined, "aria-label": ((_c = state.selectedItem) === null || _c === void 0 ? void 0 : _c.textValue) || label, ref: triggerRef, style: style, name: name, onMouseOver: function () {
                    if (clearableTimeoutRef.current) {
                        return;
                    }
                    clearableTimeoutRef.current = setTimeout(function () {
                        setHovered(true);
                    }, 300);
                }, onMouseLeave: function () {
                    if (clearableTimeoutRef.current) {
                        clearableTimeoutRef.current = undefined;
                        clearTimeout(clearableTimeoutRef.current);
                    }
                    setHovered(false);
                } }, { children: [state.selectedItem ? state.selectedItem.rendered : label, withTriggerIcon && jsx(ArrowDownIcon, { size: "s", className: styles.triggerIcon }), state.selectedItem && isClearableProp && (jsx(Tooltip, __assign({ className: styles.clearTooltip, placement: "top", id: "clear-".concat(name), content: "Clear filter" }, { children: jsx("div", __assign({ role: "button", className: styles.clearButton, onPointerDown: function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                state.setSelectedKey('');
                            }, "data-testid": "clear-button" }, { children: jsx(CloseIcon, { variant: "small" }) })) })))] })), jsx(Popover, __assign({ offset: 10, triggerRef: triggerRef, isOpen: state.isOpen, onClose: state.close, hasAutoFocus: true }, { children: jsx(ListBox, __assign({ wrapperClassName: listboxWrapperClassName, className: styles.listbox, "aria-label": label, state: state }, listboxProps)) }))] }));
};
FilterDropdown.Item = ListBox.Item;

export { FilterDropdown };
